import type {
  CreateFeedbackSubmissionInput,
  UserFeedbackSubmissionSummary,
  OnboardingPreviewFeedbackInput,
  OnboardingPreviewFeedbackReceipt,
} from "@tabbio/types";
import { api } from "./api";

export async function submitOnboardingPreviewFeedback(
  input: OnboardingPreviewFeedbackInput,
  signal: AbortSignal,
): Promise<void> {
  const res = await api.post<OnboardingPreviewFeedbackReceipt>(
    "/api/feedback/onboarding-preview",
    input,
    { signal },
  );
  if (res.error || res.data?.recorded !== true) {
    throw new Error(res.error?.message ?? "Could not submit feedback");
  }
}

export async function submitFeedback(
  input: CreateFeedbackSubmissionInput,
): Promise<UserFeedbackSubmissionSummary> {
  const res = await api.post<UserFeedbackSubmissionSummary>(
    "/api/feedback",
    input,
  );

  if (res.error || !res.data) {
    throw new Error(res.error?.message ?? "Could not submit feedback");
  }

  return res.data;
}
